import { LogIn } from '@orgus/ui/icons';
import { SignInSettingsView } from '../../auth/SignInSettingsView.tsx';
import type { SettingsSection } from '../registry.ts';

const section: SettingsSection = {
  id: 'sign-in',
  title: 'Sign-in',
  description: 'GitHub, Google and Microsoft sign-in, and who may join.',
  // Right after Members, before Teams (12) and Ownership (14).
  order: 11,
  icon: LogIn,
  Component: SignInSettingsView,
};
export default section;
